document.addEventListener('keydown', function (event) {
  if (event.ctrlKey || event.altKey || event.metaKey || event.shiftKey) return;

  const tagName = event.target.tagName;
  if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT' || event.target.isContentEditable) return;

  if (event.code.toUpperCase() === 'SLASH') {
    const searchModals = document.querySelectorAll('details-modal.header__search');
    let searchModal = null;

    for (const modal of searchModals) {
      if (modal.offsetParent !== null) {
        searchModal = modal;
        break;
      }
    }

    if (!searchModal) {
      for (const modal of searchModals) {
        if (getComputedStyle(modal).display !== 'none') {
          searchModal = modal;
          break;
        }
      }
    }

    if (!searchModal || searchModal.isOpen()) return;

    event.preventDefault();
    searchModal.querySelector('summary').click();
  }
});
